import { Component } from 'react';
import PropTypes from 'prop-types';
import Button from 'devextreme-react/button';

export class SchoolTitle extends Component {
    removeSchoolButtonOptions = {
      icon: 'trash',
      onClick: () => {
        const { removeSchool } = this.props;
        removeSchool();
      },
    }

    render() {
        const { dataForm: { SchoolName }, removeSchool, index } = this.props;
        return (
            <div style={{ display: 'flex' }}>
            <h5 style={{ marginTop: '4px', marginRight: '10px' }}>{SchoolName}</h5>
                <Button
                    style={{ marginLeft: 'auto'}}
                    icon='trash'
                    onClick={() => removeSchool(index)}
                />
            </div>
        );
    }
}
SchoolTitle.propTypes = {
  removeSchool: PropTypes.func.isRequired,
  dataForm: PropTypes.object.isRequired,
};
